import { atom } from 'jotai';

import { jotaiStore } from '@/providers/jotai/jotai-store';

/**
 * Incremented each time a LaunchDarkly identify() resolves. The React SDK re-renders only when a
 * flag value changes, so consumers that also depend on the context (e.g. whether it is still
 * anonymous) subscribe to this to re-evaluate after identify.
 */
export const ldIdentifyCountAtom = atom(0);
ldIdentifyCountAtom.debugLabel = 'ldIdentifyCount';

export function notifyLaunchDarklyIdentified(): void {
  jotaiStore.set(ldIdentifyCountAtom, (count) => count + 1);
}
